import SearchModule from '../../svelte/search-module/search-module.svelte';
import Chart from '../../svelte/chart/chart.svelte';
import DataTable from '../../svelte/datatable/datatable.svelte';
import DataPortal from '../../svelte/data-portal/data-portal.svelte';
import { mount } from 'svelte';

if (document.querySelector('.svelte-search-module')) {
  mount(SearchModule, {
    target: document.querySelector('.svelte-search-module'),
    props: { ...window.kbSearchServiceManager },
  });
}

const charts = document.querySelectorAll('.svelte-chart-standalone');
if (charts.length > 0) {
  for (const chart of Array.from(charts)) {
    mount(Chart, {
      target: chart,
      props: chart.dataset,
    });
  }
}

if (document.querySelector('.svelte-data-portal')) {
  mount(DataPortal, {
    target: document.querySelector('.svelte-data-portal'),
    props: { ...window.kbSearchServiceManager },
  });
}
